import Icon from '../components/Icon.vue'

Icon.register({"text-width":{"width":448,"height":512,"paths":[{"d":"M16 32H432C440.8 32 448 39.2 448 48V144C448 152.8 440.8 160 432 160H396.5C387.7 160 380.5 152.8 380.5 144V96H261.7V224H296C304.8 224 312 231.2 312 240V272C312 280.8 304.8 288 296 288H152C143.2 288 136 280.8 136 272V240C136 231.2 143.2 224 152 224H186.3V96H67.5V144C67.5 152.8 60.3 160 51.5 160H16C7.2 160 0 152.8 0 144V48C0 39.2 7.2 32 16 32zM443.3 372.7L363.3 292.7C354 283.4 336 288.4 336 304V352H112V304C112 289.7 94.7 282.7 84.7 292.7L4.7 372.7C-1.6 378.9-1.6 389.1 4.7 395.3L84.7 475.3C94 484.6 112 479.6 112 464V416H336V464C336 478.3 353.3 485.3 363.3 475.3L443.3 395.3C449.6 389.1 449.6 378.9 443.3 372.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/text-width.js
// module id = 6Wiw
// module chunks = 0